import type { ReactNode } from 'react';
import { guides } from './registry';

/** A guide's title and its one-line summary, from the registry the navigation reads. */
export function GuideHeader({ slug }: { slug: string }): ReactNode {
  const guide = guides.find((g) => g.slug === slug);
  return (
    <>
      <p className="scene-kicker">Developers</p>
      <h1 className="scene-title">{guide?.title}</h1>
      <p className="developers__lead">{guide?.summary}</p>
    </>
  );
}
